import { IQRcodeOptions } from '../../types/fabric/fabric-impl'
import { fabric } from 'fabric'
import QRCode from 'qrcode'
import { QRCodeToDataURLOptions } from 'qrcode'

const DEFAULT_FILL_COLOR = '#000000'

function getQRcodeOptions(options: IQRcodeOptions = {}): QRCodeToDataURLOptions {
  return {
    color: {
      dark: (options.fill as string) || DEFAULT_FILL_COLOR,
      light: '#ffffff'
    }
  }
}

const QRCodeClass = fabric.util.createClass(fabric.Image, {
  objectCaching: false,

  content: '',

  fill: DEFAULT_FILL_COLOR,

  type: 'qrcode',

  initialize(options: IQRcodeOptions, imageElement = null) {
    options || (options = {})

    const finalImageElement = imageElement || fabric.util.createImage()
    this.callSuper('initialize', finalImageElement, options)

    this.set('content', options.content || '')
  },

  cacheProperties: fabric.Image.prototype.cacheProperties!.concat('content'),

  _set: function(key: string, value: any) {
    this.callSuper('_set', key, value)
    if (key === 'content' || key === 'fill') {
      const qrcodeOptions = getQRcodeOptions(this)
      QRCode.toDataURL(this.content, qrcodeOptions, (error, url) => {
        if (error) {
          return
        }

        this.setSrc(url, () => {
          // TODO - need to reflect width and height information on the UI
          // for client side rendering
          this.canvas?.requestRenderAll()
        })
      })
    }
  },

  toObject: function() {
    return fabric.util.object.extend(this.callSuper('toObject'), {
      content: this.get('content')
    })
  },

  getSrc: function() {
    return this.src || ''
  },

  _render: function(ctx: CanvasRenderingContext2D) {
    this.callSuper('_render', ctx)
  }
})

fabric.Qrcode = QRCodeClass
fabric.Qrcode.fromObject = function(_object, callback) {
  // Copied from fabric.Image.fromObject but with small changes
  // https://github.com/fabricjs/fabric.js/blob/5.x/src/shapes/image.class.js#L705
  let object = fabric.util.object.clone(_object)
  const qrcodeOptions = getQRcodeOptions(object)

  // object.content can be overridden with empty string by users, and in that cast, it would cal
  QRCode.toDataURL(object.content, qrcodeOptions, (error, url) => {
    if (error) {
      callback && callback(null, true)
      return
    }

    fabric.util.loadImage(
      url,
      function(imageElement, isError) {
        if (isError) {
          callback && callback(null, true)
          return
        }

        fabric.Image.prototype._initFilters.call(object, object.filters, function(filters) {
          object.filters = filters || []
          fabric.Image.prototype._initFilters.call(object, [object.resizeFilter], function(
            resizeFilters
          ) {
            object.resizeFilter = resizeFilters[0]
            fabric.util.enlivenObjectEnlivables(object, object, function() {
              var qrcode = new fabric.Qrcode(object, imageElement)
              callback(qrcode, false)
            })
          })
        })
      },
      null,
      object.crossOrigin
    )
  })
}
